
const history = function () {
    const cells = document.querySelectorAll('.historia.cen');
    cells.forEach(function (cell) {
        const hiddenDiv = cell.querySelector('div');
        cell.addEventListener('click', function (event) {
            event.stopPropagation();
            document.querySelectorAll('.historia.cen .pricepin').forEach(div => {
                if (div !== hiddenDiv) {
                    div.classList.add('hidden');
                }
            });
            hiddenDiv.classList.toggle('hidden');
        });
    });
    document.addEventListener('click', function () {
        document.querySelectorAll('.historia.cen .pricepin').forEach(div => {
            div.classList.add('hidden');
        });
    });
}

export default history;